import { useTranslation } from 'react-i18next'
import { stats, whyUsPoints } from '@/mocks/site'

export default function WhyUsSection() {
  const { t } = useTranslation()

  return (
    <section className="w-full bg-background-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-primary-500" />
              <span className="section-label text-primary-700 text-[11px] md:text-xs font-medium">
                {t('why.label')}
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
              {t('why.title')}
            </h2>
            <p className="mt-6 text-base text-foreground-600 leading-relaxed">{t('why.intro')}</p>

            <div className="mt-9 grid grid-cols-2 gap-4">
              {stats.map((stat) => (
                <div key={stat.id} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className="w-10 h-10 rounded-full flex items-center justify-center bg-accent-100 text-accent-700 mb-3">
                    <i className={`${stat.icon} text-lg`} />
                  </span>
                  <div className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-600 mt-1">
                    {t(`why.stat${stat.id.toUpperCase()}`)}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {whyUsPoints.map((point) => (
              <article
                key={point.id}
                className="rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-secondary-300"
              >
                <span className="w-11 h-11 rounded-full flex items-center justify-center bg-secondary-100 text-secondary-800 mb-4">
                  <i className={`${point.icon} text-xl`} />
                </span>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                  {t(`why.points.${point.id}.title`)}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{t(`why.points.${point.id}.desc`)}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}